export default {"src":"/_next/static/media/microscope-.537e7dbb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};